const DocPages = {
  contents: 'CustomerDocs/customerdocs_index.aspx',
  troubleshooting: 'CustomerDocs/common/troubleshooting.aspx',
  templateMapper: 'CustomerDocs/admin/roster_overview.aspx',
  permissions: 'CustomerDocs/admin/users/users_permissions.aspx',
  templates: 'CustomerDocs/admin/roster_overview.aspx#templates',
  changelog: 'CustomerDocs/changelog.aspx',
  leaveStatus: 'CustomerDocs/admin/leave.aspx#leave-types-and-leave-status',
  leaveType: 'CustomerDocs/admin/leave.aspx',
  availabilityLegType: 'CustomerDocs/admin/availability.aspx#availability-leg-types',
  availabilityLegs: 'CustomerDocs/admin/availability.aspx#availability-legs',
  availabilityCycle: 'CustomerDocs/admin/availability.aspx#availability-cycles',
  competencies: 'CustomerDocs/admin/competencies.aspx',
  competencyTypes: 'CustomerDocs/admin/competencies.aspx#sap-competencies-competency-types',
  tags: 'CustomerDocs/admin/tags.aspx',
  activities: 'CustomerDocs/admin/roster_activities.aspx',
  travelItineraries: 'CustomerDocs/admin/travel.aspx',
  travelRoutes: 'CustomerDocs/admin/travel.aspx',
  travelLegs: 'CustomerDocs/admin/travel.aspx',
  travelLocations: 'CustomerDocs/admin/travel.aspx',
  travelBookings: 'CustomerDocs/admin/travel.aspx#bookings',
  actionTypes: 'CustomerDocs/admin/actions.aspx#action-types',
  actions: 'CustomerDocs/admin/actions.aspx',
  history: 'CustomerDocs/admin/audit-history.aspx'
};

export default DocPages;
